import MQ from "mathquill";
import "mathquill/build/mathquill.css";

export default MQ.getInterface(2);
